import { render, staticRenderFns } from "./nuevoPedidoADistribuidor.vue?vue&type=template&id=9c4c2c0a&scoped=true"
import script from "./nuevoPedidoADistribuidor.vue?vue&type=script&lang=js"
export * from "./nuevoPedidoADistribuidor.vue?vue&type=script&lang=js"
import style0 from "./nuevoPedidoADistribuidor.vue?vue&type=style&index=0&id=9c4c2c0a&prod&scoped=true&lang=css"
import style1 from "./nuevoPedidoADistribuidor.vue?vue&type=style&index=1&id=9c4c2c0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4c2c0a",
  null
  
)

export default component.exports